import { Location, useLocation as useOriginalLocation } from 'react-router-dom';

// Keep track of our potential state for link/navigate here
interface LocationState {
    // Track the referring route
    from?: string;

    // Create a new route branch to be able to pop any future routes off the
    // stack when closing a modal, etc.
    branch?: boolean;
}

// For some reason, React Router v6 removes generic types for the 'state'
// property of the location object. This hook restores them.
type LocationWithTypedState<T = unknown> = Omit<Location, 'state'> & { state: T };

export const useLocationWithTypedState = <T = unknown>(): LocationWithTypedState<T> => {
    const originalLocation = useOriginalLocation();

    return { ...originalLocation, state: originalLocation.state as T };
};

const useAppLocation = () => useLocationWithTypedState<LocationState>();

export default useAppLocation;
